import { useTranslation } from 'react-i18next';

export default function AboutHero() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-8 pt-28 pb-14 md:pt-32 md:pb-18 bg-background-50">
      <div className="max-w-[1280px] mx-auto text-center">
        <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300 text-foreground-700 text-xs font-medium mb-6 whitespace-nowrap">
          {t('about_hero_label')}
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight">
          {t('about_hero_title1')}
          <br />
          {t('about_hero_title2')}
          <br />
          {t('about_hero_title3')}
        </h1>
      </div>
    </section>
  );
}